/*
* Root app view (display login when unauthed, or auto redirect to app dash if authed)
*/

import * as React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import * as ReduxQueries from '../queries';
import Login from '../login/';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';

class AppRootHome extends AppComp.AppComponentNoWrapper<AppComp.IAppComponentProps, any> {
  public constructor(props: any) {
    super(props, 'app.root-home.');
  }

  public render() {
    const { branding, ...rest } = this.props;

    return (
      <div>
        <Row><Col xs={12}>&nbsp;</Col></Row>
        <Row>
          <Col xs={4} xsOffset={4}>
            {/* Branded app logo */}
            <Row>
              <Col xs={12}>
                <img src={branding.logo.login} />
              </Col>
            </Row>
            <Row>&nbsp;</Row>
            <Row>
              <Login />
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): AppComp.IAppComponentProps =>
  ReduxQueries.MapQueryStateToPropsRoot(state, props, null);
export default withRouter<AppComp.IAppComponentProps>(connect(mapStateToProps, {})(AppRootHome));



// WEBPACK FOOTER //
// ./src/app-root-home/index.tsx